import { AmenitiesStrip } from '../components/home/AmenitiesStrip';
import { Hero } from '../components/home/Hero';
import { MarqueeFacts } from '../components/home/MarqueeFacts';
import { usePageMeta } from '../lib/usePageMeta';

export function Home(): JSX.Element {
  usePageMeta();
  return (
    <>
      <Hero />
      <MarqueeFacts />
      <AmenitiesStrip />
    </>
  );
}
